const SUBSCRIPTION_ERRORS = {
  COULDNT_ACTIVATE: {
    message: "weCouldNotActivateYourSubscription",
    docUrl:
      "https://help.getnexar.com/en/articles/9099133-managing-your-nexar-connect-subscription-via-mynexar-a-user-guide-and-frequently-asked-questions-faqs#h_d66e7a07fb",
  },
  COULDNT_CANCEL: {
    message: "subscriptionCancellationFailed",
    docUrl:
      "https://help.getnexar.com/en/articles/9099133-managing-your-nexar-connect-subscription-via-mynexar-a-user-guide-and-frequently-asked-questions-faqs#h_a14349f486",
  },
  COULDNT_UPDATE: {
    message: "weCouldNotUpdateYourPaymentInformation",
    docUrl:
      "https://help.getnexar.com/en/articles/9099133-managing-your-nexar-connect-subscription-via-mynexar-a-user-guide-and-frequently-asked-questions-faqs#h_36ff95eee3",
  },
};

export default SUBSCRIPTION_ERRORS;
